import ReactDOM from 'react-dom';
import App2 from './App2';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';


ReactDOM.render(<App2 />, document.getElementById('root'));

serviceWorkerRegistration.register()